import React from "react";
import FieldString from "../../../fields3/generic/string/string";
import FieldConfig from "../../../fields3/proto/field-config";
import {GROUP_INFO} from "../../../gd/const/fields/field2-groups";
import FieldKeyboardShortcut_View from "./render/view";

export default class FieldKeyboardShortcut extends FieldString {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Url";
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Keyboard Shortcut"
        this.icon               = 'i5-globe';

        // _.assign(this.components, {
        //     ValueIcon   : <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", this.icon)}/>
        // })

        this.renderComponents.view          = FieldKeyboardShortcut_View
        this.renderComponents.viewSmall     = FieldKeyboardShortcut_View
        this.renderComponents.glistView     = FieldKeyboardShortcut_View
    }


}